import DateManagementView from './DateManagementView'

export default function DateManagementContainer() {
    return <DateManagementView />
}
